import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SagaPipeModule } from '@app/pipes/module';
import { IonicModule } from '@ionic/angular';
import { ComponentLoaderComponent } from './components/component-loader/component-loader.component';
import { ShowMoreButtonComponent } from './components/show-more-button/show-more-button.component';
import { ViewSplitterComponent } from './components/view-splitter/view-splitter.component';

const components = [ComponentLoaderComponent, ViewSplitterComponent, ShowMoreButtonComponent];

@NgModule({
  declarations: components,
  imports: [IonicModule, CommonModule, SagaPipeModule],
  providers: [],
  exports: components
})
export class VisualModule {}
